import { Component, HostListener } from '@angular/core';
import { AppMenu } from '../menu/menu.component';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [AppMenu],
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class AppSidebar {
    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        const width = window.innerWidth;

        const sidebar = document.getElementById('app-sidebar-1');
        if (!sidebar) return;

        if (width < 1024) {
            sidebar.classList.remove('lg:block');
            sidebar.classList.add('hidden');
        } else {
            sidebar.classList.remove('hidden');
            sidebar.classList.add('lg:block');
        }
    }
}
